import React, {useState, useEffect} from 'react'
import './Chat.css'
import {Avatar} from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchIcon from '@material-ui/icons/Search';
import chatImage from './chat_bg.png'
import SingleGroupChatMessage from '../SingleGroupChatMessage'
import {useParams} from 'react-router-dom'
import firebase, {db} from '../../Firebase/firebase'
import { useStore } from '../../StateManagement';
import ChatFooter from './elements/ChatFooter';


function Chat() {
  const {id} = useParams();
  const [stateData, dispatch] = useStore();
  const [messages, setMessages] = useState([]);
  const [textMessage, setTextMessage] = useState('');
  const [chatDetails, setChatDetails] = useState({name: ''});
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  
  useEffect(()=>{
    db.collection('groups').doc(id).get().then((doc)=> setChatDetails({...doc.data()}))
    db.collection('groups').doc(id).collection('messages').orderBy('time', 'asc').onSnapshot((snapshot)=> {
      setMessages(snapshot.docs.map((doc)=> ({id: doc.id, ...doc.data()})))
    })
  }, [id])

  const sendMessage = () => {
    setShowEmojiPicker(false)
    db.collection('groups').doc(id).set({
      ...chatDetails,
      lastPerson: stateData.userDetails.name,
      lastMessage: textMessage
    })

    db.collection('groups').doc(id).collection('messages').add({
      name: stateData.userDetails.name,
      time: new Date().getTime(),
      message: textMessage
    })

    setTextMessage('')
  }

  const handleSendMessageOnEnter = (e) => {
    if(e.keyCode === 13){
      sendMessage()
    }
  }

  return (
    <div className="chat">
      <div className="chat__container">
        <div className="chat__header">
          <Avatar
           src={chatDetails.groupPhotoUrl}
           className='avatar' 
           />
          <div className="chat__details">
            <h2>{chatDetails.groupName}</h2>
          </div>
          <div className="icons">
            <span>
              <SearchIcon />
            </span>
            <span>
              <MoreVertIcon />
            </span>
          </div>
        </div>
        <div className="chat__middle">
          <div className="chat__middle__container" style={{backgroundImage: `url(${chatImage})`}}>
            <div className="chat__messages">
              {messages.map((message)=> <SingleGroupChatMessage name={message.name} time={message.time} message={message.message} you={message.name === stateData.userDetails.name && true} type={message.type ? message.type : ''} voiceNoteUrl={message.voiceNoteUrl ? message.voiceNoteUrl : ''} />)}
            </div>
          </div>
        </div>
        <ChatFooter 
          sendMessage={sendMessage} 
          handleSendMessageOnEnter={handleSendMessageOnEnter}
          textMessage={textMessage}
          setTextMessage={setTextMessage}
          showEmojiPicker={showEmojiPicker}
          setShowEmojiPicker={setShowEmojiPicker}
          chatId={id}
          senderName={stateData.userDetails.name}
          chatDetails={chatDetails}
        />
      </div>
    </div>
  )
}

export default Chat
